module.exports = __webpack_public_path__ + "static/media/background.seekr.4b1f0eff.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/background.seekr.png
// module id = 556
// module chunks = 0